import { render } from "./metricRow.vue?vue&type=template&id=dc360dae&scoped=true"
import script from "./metricRow.vue?vue&type=script&lang=js"
export * from "./metricRow.vue?vue&type=script&lang=js"

import "./metricRow.vue?vue&type=style&index=0&id=dc360dae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc360dae"]])

export default __exports__